export const blockIconsUiactionsMoreHorizNew = (
	<span className='material-symbols-outlined'>more_horiz</span>
);
